export const calcDistance = (lat1, lon1, lat2, lon2) => {
  if (
    !lat1 ||
    !lon1 ||
    typeof lat2 === 'undefined' ||
    typeof lon2 === 'undefined'
  ) {
    return {}
  }
  const toRad = (val) => (val * Math.PI) / 180
  const Rkm = 6371 // earths radius in KM
  const Rm = 3958.8 // earths radius in Miles
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)
  const nlat1 = toRad(lat1)
  const nlat2 = toRad(lat2)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(nlat1) * Math.cos(nlat2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return {
    distance: Rkm * c * 1000,
    distanceInKilometers: Rkm * c,
    distanceInMiles: Rm * c,
  }
}
